// Module
var code = `<a ng-click="open_modal_form('life_time.LTVBenchmarkSettingsForm')" class="btn btn-warning btn-xs">
    Settings
</a>
<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="life_time.LTVBenchmarkChart"></bfg-chart>
    </div>
</div>

<div class="row">
    <table class="table" ng-table fixed-table-headers="scrollable-area">
        <tr>
            <th>Month</th>
            <th>Installs</th>
            <th>Buyers</th>
            <th>1</th>
            <th>7</th>
            <th>14</th>
            <th>21</th>
            <th>28</th>
            <th>35</th>
            <th>42</th>
            <th>49</th>
            <th>56</th>
            <th>63</th>
            <th>70</th>
            <th>77</th>
            <th>84</th>
            <th>91</th>
        </tr>
        <tr style="background-color: #FFEBCD">
            <td>Average</td>
            <td>{{ apply(data[0].installs) }}</td>
            <td>{{ apply(data[0].players) }}</td>
            <td>{{ apply(data[0].ltv_1) }}</td>
            <td>{{ apply(data[0].ltv_7) }}</td>
            <td>{{ apply(data[0].ltv_14) }}</td>
            <td>{{ apply(data[0].ltv_21) }}</td>
            <td>{{ apply(data[0].ltv_28) }}</td>
            <td>{{ apply(data[0].ltv_35) }}</td>
            <td>{{ apply(data[0].ltv_42) }}</td>
            <td>{{ apply(data[0].ltv_49) }}</td>
            <td>{{ apply(data[0].ltv_56) }}</td>
            <td>{{ apply(data[0].ltv_63) }}</td>
            <td>{{ apply(data[0].ltv_70) }}</td>
            <td>{{ apply(data[0].ltv_77) }}</td>
            <td>{{ apply(data[0].ltv_84) }}</td>
            <td>{{ apply(data[0].ltv_91) }}</td>
            <td></td>
        </tr>
        <tr ng-repeat="day in data.slice(1, data.length)">
            <td>{{ day.month }}</td>
            <td>{{ apply(day.installs) }}</td>
            <td>{{ apply(day.players) }}</td>
            <td ng-style="{'background-color': apply_color(day.ltv_1, 'ltv_1'),
                'border': apply_border(day.ltv_1, day.ltv_1_is_not_final)}">
                {{ apply(day.ltv_1) }}
            </td>
            <td ng-style="{'background-color': apply_color(day.ltv_7, 'ltv_7'),
                'border': apply_border(day.ltv_7, day.ltv_7_is_not_final)}">
                {{ apply(day.ltv_7) }}
            </td>
            <td ng-style="{'background-color': apply_color(day.ltv_14, 'ltv_14'),
                'border': apply_border(day.ltv_14, day.ltv_14_is_not_final)}">
                {{ apply(day.ltv_14) }}
            </td>
            <td ng-style="{'background-color': apply_color(day.ltv_21, 'ltv_21'),
                'border': apply_border(day.ltv_21, day.ltv_21_is_not_final)}">
                {{ apply(day.ltv_21) }}
            </td>
            <td ng-style="{'background-color': apply_color(day.ltv_28, 'ltv_28'),
                'border': apply_border(day.ltv_28, day.ltv_28_is_not_final)}">
                {{ apply(day.ltv_28) }}
            </td>
            <td ng-style="{'background-color': apply_color(day.ltv_35, 'ltv_35'),
                'border': apply_border(day.ltv_35, day.ltv_35_is_not_final)}">
                {{ apply(day.ltv_35) }}
            </td>
            <td ng-style="{'background-color': apply_color(day.ltv_42, 'ltv_42'),
                'border': apply_border(day.ltv_42, day.ltv_42_is_not_final)}">
                {{ apply(day.ltv_42) }}
            </td>
            <td ng-style="{'background-color': apply_color(day.ltv_49, 'ltv_49'),
                'border': apply_border(day.ltv_49, day.ltv_49_is_not_final)}">
                {{ apply(day.ltv_49) }}
            </td>
            <td ng-style="{'background-color': apply_color(day.ltv_56, 'ltv_56'),
                'border': apply_border(day.ltv_56, day.ltv_56_is_not_final)}">
                {{ apply(day.ltv_56) }}
            </td>
            <td ng-style="{'background-color': apply_color(day.ltv_63, 'ltv_63'),
                'border': apply_border(day.ltv_63, day.ltv_63_is_not_final)}">
                {{ apply(day.ltv_63) }}
            </td>
            <td ng-style="{'background-color': apply_color(day.ltv_70, 'ltv_70'),
                'border': apply_border(day.ltv_70, day.ltv_70_is_not_final)}">
                {{ apply(day.ltv_70) }}
            </td>
            <td ng-style="{'background-color': apply_color(day.ltv_77, 'ltv_77'),
                'border': apply_border(day.ltv_77, day.ltv_77_is_not_final)}">
                {{ apply(day.ltv_77) }}
            </td>
            <td ng-style="{'background-color': apply_color(day.ltv_84, 'ltv_84'),
                'border': apply_border(day.ltv_84, day.ltv_84_is_not_final)}">
                {{ apply(day.ltv_84) }}
            </td>
            <td ng-style="{
                'background-color': apply_color(day.ltv_91, 'ltv_91'),
                'border': apply_border(day.ltv_91, day.ltv_91_is_not_final)}">
                {{ apply(day.ltv_91) }}
            </td>
        </tr>
    </table>
</div>
`;
// Exports
module.exports = code;